import { render, staticRenderFns } from "./RfvCardItem.vue?vue&type=template&id=7e6b752a&scoped=true"
import script from "./RfvCardItem.vue?vue&type=script&lang=js"
export * from "./RfvCardItem.vue?vue&type=script&lang=js"
import style0 from "./RfvCardItem.vue?vue&type=style&index=0&id=7e6b752a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6b752a",
  null
  
)

export default component.exports